import { useQuery } from '@apollo/client';
import type { Channel } from 'application-types';
import { FeatureFlag } from 'constants-flags';
import { EmailTemplateType } from 'lane-shared/domains/visitorManagement/types';
import { getVisitorEmailTemplate } from 'lane-shared/graphql/visitorManagement';
import { useFlag } from 'lane-shared/hooks';
import { convertToUUID } from 'uuid-encoding';

type VisitorEmailBannerChannel = Pick<Channel, '_id' | 'parent'>;

export function useVisitorEmailTemplateBanner(
  channel: VisitorEmailBannerChannel,
  isNewChannelRelationshipFlow: boolean
) {
  const isVisitorsTenantCustomEmailBannerEnabled = useFlag(
    FeatureFlag.VisitorsTenantCustomEmailBanner,
    false
  );
  const isTenantChannel = Boolean(channel?.parent);
  const shouldShowEmailBanner =
    isVisitorsTenantCustomEmailBannerEnabled && isTenantChannel;

  const { data, loading: isVisitorEmailTemplateLoading } = useQuery(
    getVisitorEmailTemplate,
    {
      variables: {
        channelId: channel._id ? convertToUUID(channel._id) : '',
        templateType: EmailTemplateType.INVITE,
      },
      fetchPolicy: 'network-only',
      skip:
        !shouldShowEmailBanner ||
        isNewChannelRelationshipFlow ||
        !channel._id,
    }
  );

  const visitorEmailBannerId =
    data?.visitorEmailTemplate?.backgroundId ?? null;

  return {
    shouldShowEmailBanner,
    visitorEmailBannerId,
    isVisitorEmailTemplateLoading,
  };
}
